import { render } from "./SendFormComponent.vue?vue&type=template&id=1887650c&scoped=true"
import script from "./SendFormComponent.vue?vue&type=script&lang=js"
export * from "./SendFormComponent.vue?vue&type=script&lang=js"

import "./SendFormComponent.vue?vue&type=style&index=0&id=1887650c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1887650c"]])

export default __exports__